import axios from "axios";
import { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";

function LoanpaymentHistroy() {
  const { id } = useParams();
    const toast = useToast();
    const navigate = useNavigate();
  const [loanData, setLoanData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editPayment, setEditPayment] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchLoanData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
      console.log("API Response:", response.data);

      if (response.data.data && response.data.data.length > 0) {
        setLoanData(response.data.data[0]);
      } else {
        console.error("No loan data found in response");
        toast.warning("No loan data found");
      }
    } catch (error) {
      console.error("Error fetching loan data:", error);
      toast.error("Failed to load loan data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditPayment = (payment) => {
    setEditPayment({ ...payment });
    setShowEditModal(true);
  };

  const handleDeletePayment = async (id) => {
    if (window.confirm("Are you sure you want to delete this payment?")) {
      try {
        await axios.delete(`${ApiUrl}/Api/loan_payment_history.php/${id}`);
        // Refresh loan data after deletion
        await fetchLoanData();
        toast.success("Payment deleted successfully");
      } catch (error) {
        console.error("Error deleting payment:", error);
        toast.error("Failed to delete payment: " + error.message);
      }
    }
  };

  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${ApiUrl}/Api/loan_payment_history.php/${editPayment.id}`, {
        loan_id: editPayment.loan_id,
        customer_id: editPayment.customer_id,
        payment_type: editPayment.payment_type,
        payment_date: editPayment.payment_date,
        amount: editPayment.amount,
        updated_by: editPayment.updated_by, // Add this
        updated_date: new Date().toISOString(), // Or your preferred format
      });
      ;
      setShowEditModal(false);
      await fetchLoanData();
      toast.success("Payment updated successfully");
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Failed to update payment: " + error.message);
    }
  };

  useEffect(() => {
    if (id) {
      fetchLoanData();
    }
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!loanData) {
    return <div>No loan data available</div>;
  }

  return (
    <div className="container-fluid py-3">
      {/* Loan Details Card */}
 <div className="text-end mb-2">
      <button
        className="btn btn-sm btn-primary"
        onClick={() => navigate('/loan')}
      >
        Back
      </button>
    </div>
      <div
        className="card p-2 mb-3"
        style={{ borderRadius: "15px", backgroundColor: "white" }}
      >
        <h6 className="text-primary text-center mb-3">Loan Customer Details </h6>

        <div className="row">
          <div className="col-md-3">
            <label htmlFor="Loan_Id" className="form-label">
              Loan ID
            </label>
            <input
              id="Loan_Id"
              type="text"
              className="form-control"
              value={loanData.loan_id || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="Customer_id" className="form-label">
              Customer ID
            </label>
            <input
              id="customerId"
              type="text"
              className="form-control"
              value={loanData.customer?.customer_id || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="Customer_Name" className="form-label">
              Customer Name
            </label>
            <input
              id="customerName"
              type="text"
              className="form-control"
              value={loanData.customer?.name || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="Customer_Mobile" className="form-label">
              Customer Mobile
            </label>
            <input
              id="customerMobile"
              type="text"
              className="form-control"
              value={loanData.customer?.mobile || ""}
              readOnly
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label htmlFor="Customer_Address" className="form-label">
              Customer Address
            </label>
            <input
              id="customerAddress"
              type="text"
              className="form-control"
              value={loanData.customer?.address || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="Loan_date" className="form-label">
              Loan Date
            </label>
            <input
              id="Loan_date"
              type="text"
              className="form-control"
              value={loanData.loan_date || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="amount" className="form-label">
              Loan Amount
            </label>
            <input
              id="amount"
              type="text"
              className="form-control"
              value={loanData.loan_amount || ""}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="totalWorth" className="form-label">
              Overall Total
            </label>
            <input
              id="totalWorth"
              type="text"
              className="form-control"
              value={loanData.overall_total || ""}
              readOnly
            />
          </div>
        </div>
      </div>



<div
  className="card shadow-sm mb-5 border-0"
  style={{
    borderRadius: "20px",
    background: "linear-gradient(to right, #f8fbff, #e0f7fa)",
    color: "#333",
  }}
>
  <div
    className="card-body"
    style={{
      borderRadius: "15px",
      padding: "2rem",
      backgroundColor: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
    }}
  >
    <h5 className="text-center fw-semibold text-primary mb-4">
      Payment History
    </h5>

    <div className="table-responsive card">
      <table className="table table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th scope="col">S.No</th>
            <th scope="col">Date</th>
            <th scope="col">Pay Type</th>
            <th scope="col">Paid Amount</th>
            <th scope="col" className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {loanData.loan_payment_history?.length > 0 ? (
            loanData.loan_payment_history.map((payment, index) => (
              <tr key={payment.id} className="border-bottom">
                <td>{index + 1}</td>
                <td>{payment.payment_date || "--"}</td>
                <td>{payment.payment_type || "--"}</td>
                <td>${Number(payment.amount || 0).toFixed(2)}</td>
                <td className="text-center">
                  <button
                    className="btn  btn-sm  btn-light me-2"
                    onClick={() => handleEditPayment(payment)}
                    title="Edit"
                  >
                                 <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                  </button>
                  <button
                    className="btn  btn-sm  btn-light"
                    onClick={() => handleDeletePayment(payment.id)}
                    title="Delete"
                  >
                          <i className="fa-solid fa-trash text-danger fs-6"></i>
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-muted py-4">
                No payment history available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>

      

      {/* Payment History Card */}
      {/* <div
        className="card mb-5"
        style={{
          borderRadius: "15px",
          padding: "10px",
          backgroundColor: "#fff",
          color: "black",
        }}
      >
        <div
          className="card"
          style={{
            borderRadius: "15px",
            backgroundColor: "#C7F1F1",
            color: "black",
          }}
        >
          <div className="card-body">
            <h6 className="text-center mb-3">Payment History</h6>

            <div className="table-responsive">
              <table className="table table-border text-white">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Pay Type</th>
                    <th>Paid Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loanData.loan_payment_history?.length > 0 ? (
                    loanData.loan_payment_history.map((payment, index) => (
                      <tr key={payment.id}>
                        <td>{index + 1}</td>
                        <td>{payment.payment_date || ""}</td>
                        <td>{payment.payment_type || ""}</td>
                        <td>{payment.amount || ""}</td>
                        <td>
                          <button
                            className="btn btn-light btn-sm me-2"
                            onClick={() => handleEditPayment(payment)}
                          >
                            <i className="fa fa-pencil text-primary"></i>
                          </button>
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => handleDeletePayment(payment.id)}
                          >
                            <i className="fa fa-trash text-danger"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No payment history available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}

      {/* Edit Payment Modal */}
      {showEditModal && (
        <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Payment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpdatePayment}>
                  <div className="mb-3">
                    <label htmlFor="paymentType" className="form-label">
                      Payment Type
                    </label>
                    <input
                      id="paymentType"
                      type="text"
                      className="form-control"
                      value={editPayment.payment_type || ""}
                      onChange={(e) =>
                        setEditPayment({
                          ...editPayment,
                          payment_type: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="paymentDate" className="form-label">
                      Payment Date
                    </label>
                    <input
                      id="paymentDate"
                      type="text"
                      className="form-control"
                      value={editPayment.payment_date || ""}
                      onChange={(e) =>
                        setEditPayment({
                          ...editPayment,
                          payment_date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="amount" className="form-label">
                      Amount
                    </label>
                    <input
                      id="amount"
                      type="text"
                      className="form-control"
                      value={editPayment.amount || ""}
                      onChange={(e) =>
                        setEditPayment({
                          ...editPayment,
                          amount: e.target.value,
                        })
                      }
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Update Payment
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoanpaymentHistroy;